"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _styles = require("@qc-modules/styles");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _checkbox = _interopRequireDefault(require("../checkbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FiltersContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "search-filters__FiltersContainer",
  componentId: "sc-11bewwt-0"
})(["border-left:1px ", " solid;"], function (props) {
  return (0, _styles.colors)("grey", props);
});
var propTypes = {
  // Selected filters list
  activeFilters: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string,
    value: _propTypes.string
  })),
  // container class
  className: _propTypes.string,
  // All filters list
  filters: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string,
    value: _propTypes.string
  })),

  /** Input onChange function */
  onChange: _propTypes.func,

  /** Input placeholder content */
  placeholder: _propTypes.string,

  /** Content rendered in suggestions container */
  suggestions: _propTypes.node,
  // search filter title
  title: _propTypes.string,

  /** Input text value */
  value: _propTypes.string
};
var defaultProps = {
  activeFilters: [],
  title: "Filter Results"
};
/**
 * Search bar includes Input Primitive with a search icon and a container for
 * suggested search terms.
 */

var SearchFilters = function SearchFilters(_ref) {
  var activeFilters = _ref.activeFilters,
      className = _ref.className,
      filters = _ref.filters,
      onChange = _ref.onChange,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(FiltersContainer, {
    className: className,
    display: ["none", "block"],
    flexDirection: "column",
    ml: "1px",
    pl: 4,
    pt: 5,
    width: 1 / 3
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: "text-title",
    tag: "legend"
  }, _utils.defaultFontSize), title), filters ? (0, _ramda.map)(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
      key: label,
      my: 3
    }, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
      checkboxOnChange: onChange,
      isChecked: (0, _ramda.contains)(value, activeFilters),
      label: label,
      type: "checkbox",
      value: value
    }));
  }, filters) : null);
};

SearchFilters.propTypes = propTypes;
SearchFilters.defaultProps = defaultProps;
SearchFilters.displayName = "Modules.SearchFilters";
var _default = SearchFilters;
exports["default"] = _default;